<script lang="ts">
  import { Card, Button } from '$shared/components';
import { ButtonStyle } from '$shared/constants/ButtonStyle';

  interface Props {
    infoAlertLabel?: string;
    onclick?: (e: MouseEvent) => void;
  }

  let { infoAlertLabel = '', onclick }: Props = $props();
</script>

<div class="alert">
  <Card>
    <div class="alert-container">
      {#if infoAlertLabel}
        <div data-cy="infoAlert" class="text">{infoAlertLabel}</div>
      {/if}
      <Button name="backToEntity" style={ButtonStyle.Link} {onclick}>
        Please go back to entity
      </Button>
    </div>
  </Card>
</div>

<style>
  .alert {
    width: 400px;
    margin: 0 auto;
  }
  .alert-container {
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .alert-container .text {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    line-height: 22px;
    color: var(--grey-medium);
    margin-bottom: 8px;
  }
</style>
